import Phaser from 'phaser';

export function preload(key, asset) {
  this.load.audio(key, `audio/${asset}`);
}
